import React, {FC, useEffect, useState} from 'react';
import {Link} from 'gatsby';
import AutomationDetailsContent from '../automation-details-content';
import AutomationDetailsHeader from '../automation-details-header';
import Layout from '../../layout/layout';
import {PageHero} from '../../page-hero';
import Section from '../../section';
import {IPageContextAutomatin, ICard} from '../../../types';
import WorkflowCard from '../../public-workflows/workflow-card';
import AutomationCards from '../automation-cards';
import './styles.scss';
import Breadcrumb from '../../breadcrumb';
import {cleanURL} from '../../../helpers';
import NothingToShow from '../../nothingToShow';
import {arrowDownIcon, arrowRight} from '../../../images/svgIcons';
import Discovertechstack from '../../tools-api-requests/discover-tech-stack';
import Discoverwhois from '../../tools-api-requests/discover-whois';
import {automationsListForApiDocumentation} from '../../../helpers/constants';

const Automation: FC<IPageContextAutomatin> = ({pageContext}) => {
  const result = {
    ...pageContext.result.automation,
    options: [
      {label: 'Option 1', value: 0},
      {label: 'Option 2', value: 1},
    ],
    onChange: () => {},
  };

  const [showAPIDoc, setShowAPIDoc] = useState(true);

  const automations = pageContext.result.automations.slice(0, 3);

  const getToolAPI = (url: string) => {
    let Component = null;
    if (url === 'discover-tech-stack') {
      Component = <Discovertechstack />;
    } else if (url === 'discover-whois') {
      Component = <Discoverwhois />;
    }
    return Component ? (
      <div className="details-wrapper api-request">
        <div className={`header-collapse ${showAPIDoc ? 'collapsed' : ''}`} onClick={() => setShowAPIDoc(!showAPIDoc)}>
          <div className="workflows-title">{result.name} API</div>
          <div className="ml-auto">{showAPIDoc ? arrowDownIcon : arrowRight}</div>
        </div>
        {showAPIDoc ? Component : null}
      </div>
    ) : null;
  };

  const getWorkflowPath = (name: string) => {
    const singleWorkflowPath = name.toLowerCase();
    const cleanPath = singleWorkflowPath.replace(/ /g, '-');
    return `/ready-made-workflow-library/${cleanPath}`;
  };

  return (
    <Layout>
      <PageHero title="" titleSmall minHeight id="seo_home_area_automations">
        <Breadcrumb
          items={[
            {
              to: `/automations`,
              name: 'Automations',
              active: false,
            },
            {
              to: `/automations/${cleanURL(result?.type?.name || '')}`,
              name: result?.type?.name,
              active: false,
            },
            {
              to: `/automations/${cleanURL(result?.category?.name || '')}`,
              name: result?.category?.name,
              active: false,
            },
            {
              to: `/automation/${cleanURL(result.url)}`,
              name: result?.name || '',
              active: true,
            },
          ]}
        />
      </PageHero>
      <Section>
        <div className="row automation-details mx-auto mt-0 mb-3 pl-2">
          <div className="col-12 col-md-7 col-lg-6 col-xl-8 ">
            <div className="automation-details-wrapper">
              <div className="details-wrapper">
                <AutomationDetailsHeader props={{...result}} />
                <AutomationDetailsContent description={result.long_description} />
                {automationsListForApiDocumentation.includes(result.url) && (
                  <Link to={`/automation/${result.url}/api-documentation`} className="d-block mt-2">
                    {result.name} API documentation
                    {/* <svg version="1.1" id="SEO" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 128 128" style={{width: '20px', height: '20px', marginLeft: '5px'}}><g id="row1"><path fill="#825fec" id="icon:4" d="M81 57.4c-1.6-4.1-4.1-7.7-7.3-10.5l-.1-.1c-7.3-6.5-18-8.7-27.8-4.9L17.3 53C3.4 58.5-3.6 74.2 1.8 88.2c2.6 6.7 7.7 12.1 14.4 15 3.5 1.5 7.2 2.3 11 2.3 3.3 0 6.6-.6 9.8-1.9l26.9-10.5c-3.8-1-7.4-2.6-10.7-4.9l-19.3 7.5c-4.6 1.8-9.7 1.7-14.3-.3-4.6-2-8.1-5.7-9.9-10.3-3.7-9.6 1-20.5 10.7-24.2L49 49.8c2.2-.9 4.5-1.3 6.7-1.3 2.6 0 5.1.5 7.6 1.6 4.6 2 8.1 5.7 9.9 10.3 1.6 4.1 1.7 8.5.3 12.7 1.1-.1 2.3-.4 3.3-.8l5.9-2.3c.5-4.1-.1-8.4-1.7-12.6zm-6.7 29.8c-3.7 0-7.4-.8-11-2.3-6.7-2.9-11.8-8.2-14.4-15-1.3-3.4-1.9-7-1.8-10.6l8.4.3c-.1 2.5.3 4.9 1.3 7.3 1.8 4.6 5.3 8.3 9.9 10.3 4.6 2 9.7 2.1 14.3.3l26.6-10.3c4.6-1.8 8.3-5.3 10.3-9.9 2-4.6 2.1-9.7.3-14.3-3.7-9.6-14.6-14.4-24.2-10.7l-20.7 8.1-3.1-7.9L91 24.4c13.9-5.4 29.7 1.5 35.1 15.5 2.6 6.7 2.4 14.1-.5 20.8-2.9 6.7-8.2 11.8-15 14.4L84.1 85.3c-3.2 1.2-6.5 1.9-9.8 1.9z"/></g></svg> */}
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" ><path fill="#825fec" d="M115.182 106.648c-2.7 0-5.2-1-7.1-2.9-.8-.8-.8-2 0-2.8.8-.8 2-.8 2.8 0 2.3 2.3 6.2 2.3 8.5 0l19.8-19.8c2.3-2.3 2.3-6.1 0-8.5l-11.3-11.3c-2.3-2.3-6.1-2.3-8.5 0l-19.8 19.7c-2.3 2.3-2.3 6.1 0 8.5.8.8.8 2 0 2.8-.8.8-2 .8-2.8 0-3.9-3.9-3.9-10.2 0-14.1l19.8-19.8c3.9-3.9 10.3-3.9 14.2 0l11.3 11.3c3.9 3.9 3.9 10.2 0 14.1l-19.8 19.9c-1.9 1.9-4.4 2.9-7.1 2.9zM76.982 144.848c-2.6 0-5.1-1-7.1-2.9l-11.3-11.4c-3.9-3.8-3.9-10.2 0-14.1l19.8-19.8c3.8-3.8 10.4-3.8 14.1 0 .8.8.8 2 0 2.8-.8.8-2 .8-2.8 0-2.3-2.3-6.2-2.3-8.5 0l-19.7 19.8c-2.3 2.3-2.3 6.1 0 8.5l11.3 11.3c2.3 2.3 6.1 2.3 8.5 0l19.8-19.8c2.3-2.3 2.3-6.1 0-8.5-.8-.8-.8-2 0-2.8.8-.8 2-.8 2.8 0 3.9 3.9 3.9 10.2 0 14.1l-19.8 19.9c-2 1.9-4.5 2.9-7.1 2.9z"/><path fill="#282828" d="M76.982 125.548c-.5 0-1-.2-1.4-.6-.8-.8-.8-2 0-2.8l45.3-45.3c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8l-45.3 45.3c-.4.4-.9.6-1.4.6z"/></svg> */}
                  </Link>
                )}
              </div>
              {/* {getToolAPI(result.url)} */}

              {result.containedPublicWorkflows && result.containedPublicWorkflows.length > 0 && (
                <div className="details-wrapper workflows-container">
                  <div className="workflows-title">Workflows containing this automation</div>
                  <div>
                    {result.containedPublicWorkflows.map((subItem: any) => (
                      <Link to={getWorkflowPath(subItem.public_workflow_name)}>
                        <WorkflowCard
                          data={{
                            id: subItem.public_workflow_id,
                            name: subItem.public_workflow_name,
                            description: subItem.public_workflow_description,
                            tags: subItem.tags || [],
                            steps:
                              subItem.steps && subItem.steps.length > 0
                                ? subItem.steps.map((sub: any) => {
                                    return {automation: {name: sub.automation_name, icon_url: sub.automation_icon_url}};
                                  })
                                : [],
                          }}
                          state='/ready-made-workflow-library'
                        />
                      </Link>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-12 col-md-5 col-lg-6 col-xl-4">
            <div className="recommend-title">
              <div>Other similar</div>
              <div className="see-all">
                {!!automations.length ? (
                  <Link
                    to={`/automations/${cleanURL(result?.type?.name || '')}/${cleanURL(result?.category?.name || '')}`}
                  >
                    Show all
                  </Link>
                ) : (
                  <span>Show all</span>
                )}
              </div>
            </div>
            <div className="recommend-automations">
              {!!automations.length ? (
                automations.map(item => {
                  return (
                    <div className="recommend-automation">
                      <Link to={`/automation/${cleanURL(item.url)}`}>
                        <AutomationCards
                          title={item.name}
                          description={item.short_description}
                          icon={item.icon_url}
                          is_new={item.is_new}
                          rate={4.1}
                          active={true}
                          credit_price={item.credit_price}
                          premium_credit_price={item.premium_credit_price}
                          type={item.type}
                        />
                      </Link>
                    </div>
                  );
                })
              ) : (
                <NothingToShow />
              )}
            </div>
          </div>
        </div>
      </Section>
    </Layout>
  );
};

export default Automation;
